import { render, staticRenderFns } from "./WePictureButton.vue?vue&type=template&id=47034d27&"
import script from "./WePictureButton.vue?vue&type=script&lang=js&"
export * from "./WePictureButton.vue?vue&type=script&lang=js&"
import style0 from "./WePictureButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports